import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActiveserviceService } from 'src/app/Services/ActiveUsers/activeservice.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { ToastrService } from 'ngx-toastr';
import { DxService } from 'src/app/Services/NewVisitNote/dx.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { IDxCategory, IDxIcdCodes, IDXDetails, IDxComponent } from 'src/app/models/IDXDetails';
import { IDiagnosis } from 'src/app/models/IMedicationHistoryDTO';
export interface DialogData {
  alldiagnosis: IDiagnosis[];
}

@Component({
  selector: 'app-cpt-diagnosis-list',
  templateUrl: './cpt-diagnosis-list.component.html',
  styleUrls: ['./cpt-diagnosis-list.component.css']
})
export class CptDiagnosisListComponent implements OnInit {
  dxAllIcdCodes: IDiagnosis[] = [];
  dataSource1 = new MatTableDataSource(this.dxAllIcdCodes);
  displayedColumnss: string[] = ['icdcode'];
  constructor(
    public dialogRef: MatDialogRef<CptDiagnosisListComponent>, private dxService: DxService, private formBuilder: FormBuilder, private toastr: ToastrService,
     private activeserviceService: ActiveserviceService, private sharedService: SharedService
     ,@Inject(MAT_DIALOG_DATA) public data: DialogData) {

    if (sessionStorage.getItem("encounterid") != null || sessionStorage.getItem("encounterid") != undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
  }
  ngOnInit() {
       
    this.dataSource1 = new MatTableDataSource(this.data.alldiagnosis);
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }  
}
